/**
 * Provides basic JS functionality for accordions.
 */
class Accordions extends DrupalBehavior {

  onContent(context) {
    const accordionsSelector = '[data-paragraph-type="accordions"]';
    /**
     * :not selector will ensure we don't mess with nested accordions.
     */
    const notAccordionsSelector = `:not(${accordionsSelector})`;
    $(accordionsSelector, context).each(function(){
      const $accordions = $(this);
      const accordionSelector = '[data-paragraph-type="accordion"]';
      const $siblings = $accordions.find(`> ${accordionSelector}, ${notAccordionsSelector} ${accordionSelector}`);
      const clickHandler = ($accordion, $siblings) => {
        return () => {
          const $accordionContent = $accordion.children('div');
          if ($accordion.hasClass('active')) {
            gsap.to($accordionContent, {
              duration: 0.5,
              ease: 'power4.out',
              height: 0
            });
          } else {
            gsap.to($accordionContent, {
              duration: 0.5,
              ease: 'power4.out',
              height: 'auto'
            });
          }
          $accordion.toggleClass('active');
        };
      };
      $siblings.each(function() {
        const $accordion = $(this);
        const titleSelector = '[data-field-name="field_title"]';
        const $title = $accordion.find(`> ${titleSelector}, ${notAccordionsSelector} ${titleSelector}`);
        $title.unbind('click').bind('click', clickHandler($accordion, $siblings));
      });
    });
  }

}

DrupalBehavior.register('ctek_base_theme.components', 'accordions', Accordions);
